module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/medical centre-28acafa75a271e99584ce4141c985872.png";